// Icon: material-symbols:media-link-outline
// Slug: Matches a media query and stores the result in a signal.
// Description: Sets a signal to whether a media query currently matches, keeps it in sync on change, and resets the signal on cleanup.

import { attribute } from '@engine'
import { mergePaths } from '@engine/signals'
import { modifyCasing } from '@utils/text'

attribute({
  name: 'match-media',
  requirement: {
    key: 'must',
    value: 'must',
  },
  apply({ key, mods, value }) {
    const signalName = modifyCasing(key, mods)
    let query = value?.trim() ?? ''
    if (/^(["'`]).*\1$/.test(query)) {
      query = query.slice(1, -1).trim()
    }
    if (!/[()]/.test(query)) query = `(${query})`

    let mql: MediaQueryList | undefined
    try {
      mql = window.matchMedia(query)
    } catch {}

    const listener = (event: MediaQueryListEvent) =>
      mergePaths([[signalName, event.matches]])

    mergePaths([[signalName, mql?.matches ?? false]])
    mql?.addEventListener('change', listener)

    return () => {
      mql?.removeEventListener('change', listener)
      mergePaths([[signalName, null]])
    }
  },
})
